import n from "./ghl-ui.es1519.js";
import l from "./ghl-ui.es1520.js";
import e from "./ghl-ui.es1521.js";
import { ValueSetter as v } from "./ghl-ui.es1452.js";
var m = /* @__PURE__ */ function() {
  function t() {
    n(this, t), e(this, "incompatibleTokens", void 0), e(this, "priority", void 0), e(this, "subPriority", void 0);
  }
  return l(t, [{
    key: "run",
    value: function(i, o, s, u) {
      var r = this.parse(i, o, s, u);
      return r ? {
        setter: new v(r.value, this.validate, this.set, this.priority, this.subPriority),
        rest: r.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(i, o, s) {
      return !0;
    }
  }]), t;
}();
export {
  m as Parser
};
